import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getDefaultNavMenuConfigAsync = createAsyncThunk(
  'defaultNavMenuConfig/get',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', 'menu', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getNavMenuConfigAsync = createAsyncThunk(
  'navMenuConfig/get',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', 'admin/menu', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const saveNavMenuVersionAsync = createAsyncThunk(
  'navMenuConfig/save',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'admin/menu', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const publishNavMenuVersionAsync = createAsyncThunk(
  'navMenuConfig/publish',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('PUT', `admin/menu/${payload.id}/publish`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const rollbackNavMenuVersionAsync = createAsyncThunk(
  'navMenuConfig/rollback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('PUT', `admin/menu/${payload.id}/rollback`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
